import CmnBtnContainer from "../layout/components/CmnBtnContainer"

const Benefits = () => {
  return (
    <>
      <div style={{height : "100%"}} className="cmn-page-container">
        <div id="benefits-page">
          <div className="page-content-wrapper">
            <div className="content">
              <p>Benefits of Celaeno Timesheet</p>
              <CmnBtnContainer/>
            </div>
            <div className="cmn-img-container">
              <img style={{backgroundSize : "cover"}} src="/svg/benefits-page-img.svg" alt="solution home page" width="100%" height="100%"/>
            </div>
          </div>
        </div>
        <div id="benefits-wrapper">
          <div className="benefits-card">
            <h2>For Small & Medium Businesses:</h2>
            <ul>
              <li> &#x2705; Improve project cost estimation and resource allocation.</li>
              <li> &#x2705; Ensure team productivity with real-time tracking.</li>
              <li> &#x2705; Streamline invoicing and payroll processing.</li>
            </ul>
          </div>
          <div className="benefits-card">
            <h2>For Freelancers:</h2>
            <ul>
              <li> &#x2705; Track billable and non-billable hours with ease.</li>
              <li> &#x2705; Simplify client reporting and invoicing.</li>
              <li> &#x2705; Gain transparency on work patterns and efficiency.</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default Benefits;